import type { BootStatus } from '@shared/types';

function formatList(items: string[]): string {
  if (items.length === 0) {
    return 'Nimic de raportat';
  }

  return items.slice(0, 8).join(', ') + (items.length > 8 ? ` si inca ${items.length - 8}` : '');
}

function formatRepairedItems(bootStatus: BootStatus): string {
  const repairedItems = bootStatus.database.repairedItems ?? [];

  return formatList(
    repairedItems.map((item) => `${item.table}.${item.column} -> ${item.parentTable}`)
  );
}

function formatUnsafeViolations(bootStatus: BootStatus): string {
  const violations = bootStatus.database.unsafeViolations ?? [];

  return formatList(
    violations.map((violation) => `${violation.table}.${violation.column ?? `fk${violation.foreignKeyId}`} -> ${violation.parentTable}`)
  );
}

export function StorageDiagnosticScreen({ bootStatus }: { bootStatus: BootStatus }): JSX.Element {
  const repairedCount = bootStatus.database.repairedItems?.length ?? 0;
  const unsafeCount = bootStatus.database.unsafeViolations?.length ?? 0;

  return (
    <main className="av-bridge-diagnostic">
      <section className="av-bridge-diagnostic__panel" aria-labelledby="storage-diagnostic-title">
        <p className="av-bridge-diagnostic__eyebrow">Diagnostic storage</p>
        <h1 id="storage-diagnostic-title">Storage local indisponibil</h1>
        <p>
          Baza de date locala nu este intr-o stare sigura pentru editare. Aplicatia a blocat incarcarea workspace-ului ca sa
          evite erori separate la proiecte, lead-uri sau preferinte.
        </p>

        <dl className="av-bridge-diagnostic__facts">
          <div>
            <dt>Status</dt>
            <dd>{bootStatus.database.state ?? 'blocked'}</dd>
          </div>
          <div>
            <dt>Mesaj</dt>
            <dd>{bootStatus.database.message ?? 'Verificarea storage-ului a esuat.'}</dd>
          </div>
          <div>
            <dt>Reparatii sigure</dt>
            <dd>{repairedCount}</dd>
          </div>
          <div>
            <dt>Blocaje ramase</dt>
            <dd>{unsafeCount}</dd>
          </div>
        </dl>

        {bootStatus.database.backupPath ? (
          <div className="av-bridge-diagnostic__details">
            <strong>Backup creat</strong>
            <span>{bootStatus.database.backupPath}</span>
          </div>
        ) : null}

        {repairedCount > 0 ? (
          <div className="av-bridge-diagnostic__details">
            <strong>Referinte reparate automat</strong>
            <span>{formatRepairedItems(bootStatus)}</span>
          </div>
        ) : null}

        {unsafeCount > 0 ? (
          <div className="av-bridge-diagnostic__details">
            <strong>Referinte care necesita interventie</strong>
            <span>{formatUnsafeViolations(bootStatus)}</span>
          </div>
        ) : null}

        <div className="av-bridge-diagnostic__actions">
          <button type="button" onClick={() => window.location.reload()}>
            Reincarca
          </button>
        </div>

        <p className="av-bridge-diagnostic__hint">
          Ruleaza diagnosticul storage din proiect si reporneste aplicatia dupa reparatie. Workspace-ul complet ramane blocat
          pana cand baza de date trece verificarea de integritate.
        </p>
      </section>
    </main>
  );
}
